define('common/ko/customBinding/dispatch',['jquery', 'knockout', 'underscore'], function ($, ko, _) {
    var DispatchViewModel = function($element, command, dispatchCallback) {
        var self = this;
        self.command = ko.observable(command);
        self.dispatchCallback = ko.observable(dispatchCallback);

        self.dispatch = function() {
            dispatchCallback = self.dispatchCallback();
            if(dispatchCallback === true) {
                $element.closest('form').find('input:submit').click();
            } else
                self.command().dispatch(dispatchCallback);
        };

        self.loading = ko.pureComputed(function() {
            var command = self.command();
            return command ? command.loading() : false;
        });

        self.dispose = function() {
            self.loading.dispose();
        };
    };

    // If the element is a button or a-tag it will bind a click handler to the dispatch of a command,
    // will also disable the element during the time the command is in state dispatch state.
    // Note: Must be in the context of a command (the current $data must be a command), can be overidden using the command-binding
    //value - the dispatch callback to be called when the commands is successfully dispatched or true if the dispatch
    //        is done by a surrounding form-element in which case the parent form will be found and submitted
    //other bindings:
    //command - the command to use, defaults to bindingContext.$data
    //hiddenSubmit - if set to true there will be a hidden submit added for catching submits, or if the element itself is a submit it will be hidden
    ko.bindingHandlers.dispatch = {
        init:function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var dispatchCallback = ko.unwrap(valueAccessor());
            var command = ko.unwrap(allBindingsAccessor().command) || bindingContext.$data;

            var $element = $(element);
            var dispatchViewModel = new DispatchViewModel($element, command, dispatchCallback);
            ko.utils.domData.set(element, 'dispatchViewModel', dispatchViewModel);

            var disposables = [];
            disposables.push(dispatchViewModel);

            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                _.invokeMap(disposables, 'dispose');
            });

            var bindings = {
                disable:dispatchViewModel.loading,
                css: {loading: dispatchViewModel.loading}
            };

            var tagName = (element.tagName || '').toUpperCase();
            var type = (element.type || '').toUpperCase();
            var isATag = tagName === 'A';
            if (isATag || tagName === 'BUTTON' || (tagName === 'INPUT' && type === 'SUBMIT')) {
                bindings.click = dispatchViewModel.dispatch;
                /* jshint ignore:start */
                if (isATag) {
                    bindings.attr = { href: 'javascript:void(0)' };
                }
                /* jshint ignore:end */
            }
            ko.applyBindingsToNode(element, bindings, bindingContext);
        },
        update:function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var dispatchViewModel = ko.utils.domData.get(element, 'dispatchViewModel');

            var command = ko.unwrap(allBindingsAccessor().command) || bindingContext.$data;
            if (!_.isEqual(dispatchViewModel.command(), command))
                dispatchViewModel.command(command);

            var dispatchCallback = ko.unwrap(valueAccessor());
            if(!_.isEqual(dispatchCallback, dispatchViewModel.dispatchCallback()))
                dispatchViewModel.dispatchCallback(dispatchCallback);
        }
    };
});

